import { getCMSContent } from '../../services/cms'
import { formatDate } from '../../utils/date'

/*
  TOPICS MODEL
    {
      id: string,
      title: string,
      categories: string[],
      image: string | null,
      body: string,
      date: ISO Date,
      comments: number
    }

  TEAMMATES & SHOUTOUTS model
    {
      id: string,
      name: string,
      designation: string,
      image: string | null
    }

  CATEGORIES MODEL: string[]
*/
export default {
  namespaced: true,
  state: {
    downloadURL: null,
    videoLink: null,
    illustrations: [],
    showcase: [],
    briefhistory: null,
    teamdescription: null,
    shoutoutdescription: null,
    teammates: [],
    shoutouts: [],
    topics: [],
    categories: [],
    contactLinks: {
      facebook: null,
      instagram: null,
      twitter: null,
      youtube: null,
      email: null,
      phone: null
    }
  },
  getters: {
    DOWNLOAD_URL: (state) => state.downloadURL,
    VIDEO_LINK: (state) => state.videoLink,
    ILLUSTRATIONS: (state) => state.illustrations,
    SHOWCASE: (state) => state.showcase,
    BRIEF_HISTORY: (state) => state.briefhistory,
    TEAM_DESCRIPTION: (state) => state.teamdescription,
    SHOUTOUT_DESCRIPTION: (state) => state.shoutoutdescription,
    TEAMMATES: (state) => state.teammates,
    SHOUTOUTS: (state) => state.shoutouts,
    CATEGORIES: (state) => state.categories,
    TOPICS: (state) => state.topics,
    CONTACT: (state) => state.contactLinks
  },
  actions: {
    async POPULATE_HOME({ state }) {
      const query = await getCMSContent(`
        {
          queryHomeContents {
            id,
            flatData {
              downloadLink,
              videoLink {
                url
              },
              illustrations {
                url
              },
              showcase {
                url
              }
            }
          }
        }
      `)

      if (!query) {
        return null
      }

      const { queryHomeContents } = query

      const {
        downloadLink,
        videoLink,
        illustrations,
        showcase
      } = queryHomeContents[0].flatData

      state.downloadURL = downloadLink
      state.videoLink = videoLink[0].url
      state.illustrations = illustrations ? illustrations.map((i) => i.url) : []
      state.showcase = showcase ? showcase.map((i) => i.url) : []
    },
    async POPULATE_ABOUT({ state }) {
      const query = await getCMSContent(`
      {
        queryTeammatesContents {
          id,
          flatData {
            name,
            designation,
            image {
              url
            }
          }
        },

        queryShoutoutsContents {
          id,
          flatData {
            name,
            designation,
            image {
              url
            }
          }
        },

        queryAboutContents {
          id,
          flatData {
            briefhistory,
            teamdescription,
            shoutoutdescription
          }
        }
      }
      `)

      if (!query) {
        return null
      }

      const {
        queryAboutContents,
        queryShoutoutsContents,
        queryTeammatesContents
      } = query

      const {
        briefhistory,
        shoutoutdescription,
        teamdescription
      } = queryAboutContents[0].flatData

      state.briefhistory = briefhistory
      state.shoutoutdescription = shoutoutdescription
      state.teamdescription = teamdescription

      state.shoutouts = queryShoutoutsContents.map(({ flatData }) => ({
        name: flatData.name,
        designation: flatData.designation,
        imgURL:
          flatData.image && flatData.image.length ? flatData.image[0].url : null
      }))

      state.teammates = queryTeammatesContents.map(({ flatData }) => ({
        name: flatData.name,
        designation: flatData.designation,
        imgURL:
          flatData.image && flatData.image.length ? flatData.image[0].url : null
      }))
    },
    async POPULATE_FORUMS({ state, dispatch }) {
      state.topics = []
      state.categories = []

      const query = await getCMSContent(`
      {
        queryTopicsContents {
          id,
          flatData {
            title,
            category,
            body,
            image {
              url
            }
          },
          created
        }
      }
      `)

      if (!query) {
        return null
      }

      const { queryTopicsContents } = query

      const categories = []

      for (const { id, created, flatData } of queryTopicsContents) {
        categories.push(...flatData.category)
        const total = await dispatch('comments/GET_TOTAL', id, { root: true })
        state.topics.push({
          id,
          title: flatData.title,
          categories: flatData.category,
          image:
            flatData.image && flatData.image.length
              ? flatData.image[0].url
              : null,
          body: flatData.body,
          date: Number(formatDate(created, 'x')),
          comments: total
        })
      }

      state.categories = [...new Set(categories)]
    },
    async GET_TOPIC(_, id) {
      if (!id) {
        return null;
      }

      const query = await getCMSContent(`
        {
          findTopicsContent(id: "${id}") {
            flatData {
              title
            }
          }
        }
      `)

      const { findTopicsContent } = query;
      return findTopicsContent.flatData || null;
    },
    async POPULATE_CONTACTS({ state }) {
      const query = await getCMSContent(`
      {
        queryContactusContents {
          flatData {
            facebook,
            instagram,
            twitter,
            youtube,
            email,
            phone,
          }
        }
      }
      `)

      const { queryContactusContents } = query
      console.log(queryContactusContents)
      const result = queryContactusContents[0]
      const { flatData } = result
      const toInclude = {}
      for (const [key, val] of Object.entries(flatData)) {
        if (val) {
          toInclude[key] = val;
        }
      }
      state.contactLinks = { ...toInclude }
    }
  }
}
